// Accordéons accessibles en Vanilla JS
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion, index) => {
    const title = accordion.querySelector(".accordion__title");
    const content = accordion.querySelector(".accordion__content");

    // Ajouter les attributs ARIA
    const contentId = "accordion-content-" + index;
    const titleId = "accordion-title-" + index;

    title.setAttribute("role", "button");
    title.setAttribute("aria-expanded", "false");
    title.setAttribute("aria-controls", contentId);
    title.setAttribute("id", titleId);
    title.setAttribute("tabindex", "0");

    content.setAttribute("role", "region");
    content.setAttribute("aria-labelledby", titleId);
    content.setAttribute("id", contentId);
    content.setAttribute("hidden", "true");

    // Fonction d'ouverture/fermeture
    const toggleAccordion = () => {
      const isOpen = accordion.classList.contains("active");

      accordions.forEach((acc) => {
        acc.classList.remove("active");
        acc.querySelector(".accordion__title").setAttribute("aria-expanded", "false");
        acc.querySelector(".accordion__content").setAttribute("hidden", "true");
      });

      if (!isOpen) {
        accordion.classList.add("active");
        title.setAttribute("aria-expanded", "true");
        content.removeAttribute("hidden");
      }
    };

    title.addEventListener("click", toggleAccordion);
    
    title.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleAccordion();
      }
    });
  });
});
